// Generated from src/img/svg/s7.svg

export const S7 = (props) => {
  return (
    <svg viewBox="0 0 26 13" {...props}>
      <rect fill="#933126" height="13" rx="6.5" width="25" x=".5" />
      <g
        aria-label="S7"
        style={{
          fill: "#fff",
          fontFamily: 'HelveticaNeue-Bold,"Helvetica Neue",sans-serif',
          fontSize: "10px",
          fontWeight: "700",
          transform: "translate(.5px,0)",
        }}
      >
        <path d="M6.715 7.63h1.52q0 .67.48 1.02.41.3 1.1.3.54 0 .9-.17.49-.23.49-.72 0-.61-1.1-.92-1.9-.54-2.05-.62-1.1-.53-1.1-1.67 0-1.03.85-1.63.76-.53 1.82-.53 1.23 0 1.99.53.87.61.87 1.77h-1.52q-.06-1.08-1.41-1.08-.43 0-.73.18-.35.22-.35.63 0 .39.39.57.3.14 1.74.51.84.21 1.25.48.87.56.87 1.6 0 1.02-.76 1.64-.8.65-2.21.65-1.29 0-2.12-.61-.93-.69-.92-1.93M18.135 3v1.22q-1.04.91-1.69 2.67-.58 1.59-.6 3.11h-1.52q.24-3.15 2.35-5.68h-3.32V3Z" />
      </g>
    </svg>
  );
};
